import { render } from "./VabeneTauxOrderCategorieDate.vue?vue&type=template&id=fb1d45dc&ts=true"
import script from "./VabeneTauxOrderCategorieDate.vue?vue&type=script&lang=ts"
export * from "./VabeneTauxOrderCategorieDate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__